module.exports = __webpack_public_path__ + "img/zap.4052d518.png";